var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhoneEdit = function SvgIconPhoneEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.4,
    height: 26.4,
    x: 0.9,
    y: 0.9,
    fill: "#F15A24",
    rx: 13.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#icon_phone_edit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.774 19.63c-.312 0-.617-.132-.834-.371a1.32 1.32 0 0 1-.334-1.013l.225-2.188c.03-.317.167-.611.377-.835l6.085-6.495c.95-1.013 2.617-1.013 3.567 0 .987 1.051.987 2.752 0 3.804l-6.084 6.487c-.217.232-.5.371-.805.402l-2.088.209zm7.303-10.608c-.407 0-.784.17-1.067.471L9.926 15.98a.3.3 0 0 0-.087.186l-.225 2.188c0 .07.022.116.044.14a.15.15 0 0 0 .13.046l2.089-.21c.065 0 .13-.038.181-.092l6.084-6.471a1.686 1.686 0 0 0 0-2.274 1.45 1.45 0 0 0-1.065-.471M18.44 21.168H9.368c-.283 0-.508-.24-.508-.54 0-.302.225-.542.508-.542h9.072c.283 0 .508.24.508.541s-.225.541-.508.541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.504 13.382a.5.5 0 0 1-.355-.154l-2.698-2.83a.557.557 0 0 1 0-.766.478.478 0 0 1 .718 0l2.698 2.83a.557.557 0 0 1 0 .766.5.5 0 0 1-.363.162z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_phone_edit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.5 7.968h13.2v13.2H7.5z"
  })))));
};
export default SvgIconPhoneEdit;